import { Routes, RouterModule } from "@angular/router";
import { ModuleWithProviders } from "@angular/core";
import {
  BidlineGuard,
  HomeGuard,
  LoginRouteGuard,
  RegistrationGuard,
  PrivacyPolicyGuard
} from "./shared/utility/RoutingGuard";

const routes: Routes = [
  { path: "",
    pathMatch: "full",
    redirectTo: "login" },
  {
    path: "login",
    canActivate: [LoginRouteGuard],
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule),
  },
  {
    path: "home",
    canActivate: [HomeGuard],
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
  },
  {
    path: "registration",
    canActivate: [RegistrationGuard],
    loadChildren:
      () => import('./modules/user-registration/user-registration.module').then(m => m.UserRegistrationModule),
  },
  {
    path: "bidline",
    canActivate: [BidlineGuard],
    loadChildren: () => import('./modules/bid-line/bid-line.module').then(m => m.BidLineModule),
  },
  {
    path: "privacy-policy",
    canActivate: [PrivacyPolicyGuard],
    loadChildren: () => import('./modules/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule),
  },
  {
    path: "**",
    canActivate: [LoginRouteGuard],
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule),
  },
];

export const routing: ModuleWithProviders<any> = RouterModule.forRoot(routes, {});
